export default {
    cover: {
        text: 'Find Your Services Here',
        button: 'EXPLORE HERE',
        no_offers: 'Currently there are no services for this category',
        show_all: 'Show all',
    },
    widget: {
        book_experience: 'Book your experience',
        top_companies: 'Top companies',
        find_offers: 'Find services',
    },
    subdomain: {
        popular_offer: 'Most popular services',
        show_more: 'Show all',
    },
}
